var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpendCategoryCash32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DDL-CBA---Icons-Mobile",
    transform: "translate(-1230.000000, -732.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon//SpendCategory/Cash32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconCash",
    transform: "translate(4.000000, 9.000000)",
    fill: "#706D6E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,1 L1,13 L23,13 L23,1 L1,1 Z M0,0 L24,0 L24,14 L0,14 L0,0 Z",
    id: "Note"
  }), /*#__PURE__*/React.createElement("g", {
    id: "$",
    transform: "translate(17.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,6.07142857 L0.5,5.07142857 L2.21518009,5.07142857 L2.21518009,6.07142857 L0.5,6.07142857 Z M2,2.92857143 L2,3.92857143 L1.57142857,3.92857143 L1.57142857,2.92857143 L2,2.92857143 Z M1.5,1.78571429 L1.5,0.785714286 L3.1,0.785714286 L3.1,1.78571429 L1.5,1.78571429 Z",
    id: "Arms"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.57142857,0.785714286 L1.57142857,1.78571429 C1.25583729,1.78571429 1,2.04155157 1,2.35714286 C1,2.67273414 1.25583729,2.92857143 1.57142857,2.92857143 L1.57142857,3.92857143 C0.703552536,3.92857143 0,3.22501889 0,2.35714286 C0,1.48926682 0.703552536,0.785714286 1.57142857,0.785714286 Z",
    id: "Curve"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57142857,2.92857143 L3.57142857,3.92857143 C3.25583729,3.92857143 3,4.18440871 3,4.5 C3,4.81559129 3.25583729,5.07142857 3.57142857,5.07142857 L3.57142857,6.07142857 C2.70355254,6.07142857 2,5.36787604 2,4.5 C2,3.63212396 2.70355254,2.92857143 3.57142857,2.92857143 Z",
    id: "Curve-bottom",
    transform: "translate(2.785714, 4.500000) scale(-1, 1) translate(-2.785714, -4.500000) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stick-top",
    points: "2.5 1.28571429 1.5 1.28571429 1.5 0 2.5 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stick-bottom",
    points: "2.5 6.85714286 1.5 6.85714286 1.5 5.57142857 2.5 5.57142857"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpendCategoryCash32);
export default __webpack_public_path__ + "static/media/spendCategoryCash32.813bddfb7c214f349c776a3493f0cbba.svg";
export { ForwardRef as ReactComponent };